import styled from 'styled-components';

export const StyledRoadmapContainer = styled.div`
  display: flex;
  padding: 4.6rem 1rem;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  h1 {
    color: #f9f9fb;
  }
  p {
    color: #eeeff2;
  }
`;

export const StyledTitleContainer = styled.div<{ $hideTitleDivider?: boolean }>`
  h2 {
    font-size: 3.2rem;
    ${({ $hideTitleDivider }) =>
      $hideTitleDivider &&
      `
        :after {
          content: none;
        }
      `}
  }
  p {
    ${({ $hideTitleDivider }) =>
      $hideTitleDivider &&
      `
        margin-bottom: 1.6rem;
      `}

    font-size: 1.6rem;
  }
`;

export const StyledSwitchContainer = styled.div`
  button[aria-pressed='false'] {
    background-color: #212c42;
    color: #f9f9fb;
    &:hover {
      background-color: #a3ea2a4d;
      color: #f9f9fb;
    }
  }
`;
